import React, { useContext, useEffect, useState } from "react";
import useAuth from "../../hooks/useAuth";
import { Route, Routes, useNavigate } from "react-router-dom";
import AppContext from "../../AppContext";
import FAQ from "../../components/Support/FAQ";
import TicketsPage from "./Tickets";
import Support from "../../components/Support";
import _ from "lodash";

const SupportPage = (props) => {
  const { user } = useContext(AppContext);
  const navigate = useNavigate();

  const handleOpenTicket = () => {
    navigate("/tickets/open");
  };

  return (
    <Routes>
      <Route path="faqs" element={<FAQ onOpenTicket={handleOpenTicket} />} />
      <Route path="tickets/*" element={<TicketsPage />} />
      <Route path="/*" element={<Support />} />
    </Routes>
  );
};

SupportPage.propTypes = {};

export default SupportPage;
